export const BRAND_NAME = "PaisaCX";
/** PaisaCX mark (served from `frontend/public/assets/paisacx/paisacx-mark.png`). */
export const BRAND_LOGO_SRC = "/assets/paisacx/paisacx-mark.png";
/** Full PaisaCX logo lockup. */
export const BRAND_LOGO_FULL_SRC = "/paisacx-logo.png";
/** Deep brand tone used behind the mark on gradient panels. */
export const BRAND_LOGO_BLUE = "#03080d";
